/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Integrations_G_InvoiceInputs */

const tr_landing_integrations_g_invoice = /** @type {(inputs: Landing_Integrations_G_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Fatura · e-Arşiv`)
};

const en_landing_integrations_g_invoice = /** @type {(inputs: Landing_Integrations_G_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Invoice · e-Archive`)
};

const de_landing_integrations_g_invoice = /** @type {(inputs: Landing_Integrations_G_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Rechnung · e-Archiv`)
};

const ru_landing_integrations_g_invoice = /** @type {(inputs: Landing_Integrations_G_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Fatura · e-Arşiv`)
};

/**
* | output |
* | --- |
* | "e-Invoice · e-Archive" |
*
* @param {Landing_Integrations_G_InvoiceInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_integrations_g_invoice = /** @type {((inputs?: Landing_Integrations_G_InvoiceInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Integrations_G_InvoiceInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_integrations_g_invoice(inputs)
	if (locale === "de") return de_landing_integrations_g_invoice(inputs)
	if (locale === "ru") return ru_landing_integrations_g_invoice(inputs)
	return tr_landing_integrations_g_invoice(inputs)
});